.modal-body{border-top:1px solid #e2e2e2}
/*# sourceMappingURL=test-case-template-index.component-LVU34BEY.css.map */
